import React from 'react'
import { Link,Route,BrowserRouter as Router,Switch} from 'react-router-dom'
import '../styles/HotAccessoriesMenu.css'
import Music from '../component/HotAccessoriesMenu/Music';
import Smartdevice from '../component/HotAccessoriesMenu/Smartdevice';
import Home from './HotAccessoriesMenu/Home';
import Lifestyle from './HotAccessoriesMenu/Lifestyle';
import MobileAccessories from './HotAccessoriesMenu/MobileAccessories';


const HotAccessoriesMenu = ({hotAccessories,hotAccessoriesCover}) => {
    console.log("HotAccessories",hotAccessories);
    console.log("HotAccessoriescover",hotAccessoriesCover);
    return (
    <>
      
        <div className="HotAccessoriesMenu">
          
       
            <Link className="HotAccessoriesLink" to="/music">Music Store</Link>
            <Link className="HotAccessoriesLink" to="/smartDevices">Smart Devices</Link>
            <Link className="HotAccessoriesLink" to="/home">Home</Link>
            <Link className="HotAccessoriesLink" to="/lifestyle">Lifestyle</Link>
            <Link className="HotAccessoriesLink" to="/mobileAccessories">Mobile Accessories</Link>
          
        </div>  
        
        <div>
         <Switch>   
         {/* <Route exact path="/"><Music hotAccessories={hotAccessories} hotAccessoriesCover={hotAccessoriesCover}></Music></Route>      */}
        <Route exact path="/music"><Music hotAccessories={hotAccessories} hotAccessoriesCover={hotAccessoriesCover}></Music></Route>
        <Route exact path="/smartDevices"><Smartdevice hotAccessories={hotAccessories} hotAccessoriesCover={hotAccessoriesCover}></Smartdevice></Route>
        <Route exact path="/home"><Home hotAccessories={hotAccessories} hotAccessoriesCover={hotAccessoriesCover}></Home></Route>
        <Route exact path="/lifestyle"><Lifestyle hotAccessories={hotAccessories} hotAccessoriesCover={hotAccessoriesCover}></Lifestyle></Route>
        <Route exact path="/mobileAccessories"><MobileAccessories hotAccessories={hotAccessories} hotAccessoriesCover={hotAccessoriesCover}></MobileAccessories></Route>
        <Route path="/"><Music hotAccessories={hotAccessories} hotAccessoriesCover={hotAccessoriesCover}></Music></Route>
        </Switch>
        </div>     
          

        
    
       
    </>
    )
}

export default HotAccessoriesMenu
